export const STORAGE_KEYS_PREFIX = 'skippay';

export type LOCAL_STORAGE_KEYS = 'locale';
